import React, { useEffect, useRef, useState } from "react";
import { Spin, Switch } from "antd";
import { ErrorMessage, Field, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";

import { Constants } from "../../Constants";
import { types } from "../../store/action_types";
import CustomTextInput from "../CustomTextInput";
import { UploadImage } from "../UploadImage";

const AddOrEditBlockchain = ({
  handleCloseModal,
  isFirstTime,
  setIsFirstTime,
  currentBlockchain,
  isEdit,
  page,
}) => {
  const { createLoading, editLoading } = useSelector(
    (state) => state.BlockchainsReducer
  );
  const BoastImageLink = useSelector(
    (state) => state?.BoostReducer?.uploadBoastimageAllData?.result?.imgLink
  );
  const loading = createLoading || editLoading;
  const [imageFile, setImageFile] = useState(null);
  const formikRef = useRef();
  const dispatch = useDispatch();

  const handleResetForm = () => {
    setImageFile(null);
    formikRef.current.resetForm({
      values: {
        name: "",
        symbol: "",
        iconImgUrl: "",
        explorerUrl: "",
        chainId: 0,
        priceInUsd: 0,
        nativeCurrency: "",
        rpcUrl: "",
        status: false,
      },
    });
  };

  useEffect(() => {
    if (isEdit) {
      formikRef.current.setFieldValue("name", currentBlockchain.name);
      formikRef.current.setFieldValue("symbol", currentBlockchain.symbol);
      formikRef.current.setFieldValue(
        "iconImgUrl",
        currentBlockchain.iconImgUrl
      );
      formikRef.current.setFieldValue(
        "explorerUrl",
        currentBlockchain.explorerUrl
      );
      formikRef.current.setFieldValue(
        "priceInUsd",
        currentBlockchain.priceInUsd
      );
      formikRef.current.setFieldValue("chainId", currentBlockchain.chainId);

      formikRef.current.setFieldValue(
        "nativeCurrency",
        currentBlockchain.nativeCurrency
      );
      formikRef.current.setFieldValue("rpcUrl", currentBlockchain.rpcUrl);
      formikRef.current.setFieldValue("status", currentBlockchain.status);
    } else {
      formikRef.current.setFieldValue("name", "");
      formikRef.current.setFieldValue("symbol", "");
      formikRef.current.setFieldValue("iconImgUrl", "");
      formikRef.current.setFieldValue("explorerUrl", "");
      formikRef.current.setFieldValue("priceInUsd", "");
      formikRef.current.setFieldValue("chainId", "");
      formikRef.current.setFieldValue("nativeCurrency", "");
      formikRef.current.setFieldValue("rpcUrl", "");
      formikRef.current.setFieldValue("status", false);
    }
  }, [currentBlockchain]);

  return (
    <div>
      <div className="modaltitle">
        {`${isEdit ? "Edit" : "Add"}`} Blockchain
      </div>
      <Formik
        key="my-form"
        initialValues={{
          name: "",
          symbol: "",
          iconImgUrl: "",
          explorerUrl: "",
          priceInUsd: 0,
          chainId: 0,
          nativeCurrency: "",
          rpcUrl: "",
          status: false,
        }}
        enableReinitialize={false}
        innerRef={formikRef}
        validationSchema={
          isEdit
            ? Constants.EditBlockchainSchema
            : Constants.AddBlockchainSchema
        }
        onSubmit={(values, { resetForm }) => {
          if (isEdit) {
            const updatedBody = {
              blockchainId: currentBlockchain._id,
              priceInUsd: values.priceInUsd,
              status: values.status,
            };
            dispatch({
              type: types.EditBlockchainsRequest,
              payload: {
                updatedBody,
                handleCloseModal: () => {
                  handleCloseModal();
                  resetForm();
                },
                page,
              },
            });
          } else {
            let formData = new FormData();
            formData.append("name", values.name);
            formData.append("symbol", values.symbol);
            formData.append("iconImgUrl", !!imageFile ? BoastImageLink : "");
            formData.append("explorerUrl", values.explorerUrl);
            formData.append("priceInUsd", values.priceInUsd);
            formData.append("chainId", values.chainId);
            formData.append("nativeCurrency", values.nativeCurrency);
            formData.append("rpcUrl", values.rpcUrl);
            formData.append("status", values.status);
            dispatch({
              type: types.CreateBlockchainsRequest,
              payload: {
                formData,
                handleCloseModal: () => {
                  handleCloseModal();
                  resetForm();
                },
                page,
              },
            });
          }
        }}
      >
        {({
          handleChange,
          handleBlur,
          handleSubmit,
          values,
          setFieldValue,
        }) => (
          <div className="formContainer">
            <div className="formHeader">
              <div className="formFields">
                <div
                  style={{
                    display: "flex",
                    gap: 32,
                    flexDirection: "row",
                  }}
                >
                  <UploadImage
                    setImageFile={setImageFile}
                    ErrorMessage={ErrorMessage}
                    setIsFirstTime={setIsFirstTime}
                    isFirstTime={isFirstTime}
                    formikRef={formikRef}
                    isEdit={isEdit}
                    currentPool={{ icon: currentBlockchain?.iconImgUrl }}
                    loading={loading}
                  />
                  <div
                    style={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "row",
                      paddingTop: 24,
                      gap: 24,
                    }}
                  >
                    <Field name="symbol">
                      {({ meta }) => (
                        <CustomTextInput
                          label={"Symbol"}
                          type="text"
                          error={meta.touched ? meta.error : null}
                          onChange={(e) => {
                            if (e.target.value.length <= 75)
                              handleChange("symbol")(e);
                          }}
                          placeHolderText={"Enter symbol..."}
                          value={values.symbol}
                          onBlur={handleBlur("symbol")}
                          showEyeIcon={false}
                          required={true}
                          disable={loading || isEdit}
                        />
                      )}
                    </Field>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 4,
                        alignItems: "center",
                      }}
                    >
                      <label>Status*</label>
                      <Field name="status">
                        {() => (
                          <Switch
                            checked={values.status}
                            disabled={loading}
                            onChange={(checked) =>
                              setFieldValue("status", checked)
                            }
                          />
                        )}
                      </Field>
                    </div>
                  </div>
                </div>

                <Field name="name">
                  {({ meta }) => (
                    <CustomTextInput
                      label={"Name"}
                      type="text"
                      error={meta.touched ? meta.error : null}
                      onChange={(e) => {
                        if (e.target.value.length <= 50)
                          handleChange("name")(e);
                      }}
                      placeHolderText={"Enter name..."}
                      value={values.name}
                      onBlur={handleBlur("name")}
                      showEyeIcon={false}
                      required={true}
                      disable={loading || isEdit}
                    />
                  )}
                </Field>
                <Field name="explorerUrl">
                  {({ meta }) => (
                    <CustomTextInput
                      label={"Explorer url"}
                      type="text"
                      error={meta.touched ? meta.error : null}
                      onChange={(e) => {
                        if (e.target.value.length <= 400)
                          handleChange("explorerUrl")(e);
                      }}
                      placeHolderText={"Enter explorer url..."}
                      value={values.explorerUrl}
                      onBlur={handleBlur("explorerUrl")}
                      showEyeIcon={false}
                      required={true}
                      disable={loading || isEdit}
                    />
                  )}
                </Field>
                <Field name="rpcUrl">
                  {({ meta }) => (
                    <CustomTextInput
                      label={"PRC url"}
                      type="text"
                      error={meta.touched ? meta.error : null}
                      onChange={(e) => {
                        if (e.target.value.length <= 400)
                          handleChange("rpcUrl")(e);
                      }}
                      placeHolderText={"Enter RPC url..."}
                      value={values.rpcUrl}
                      onBlur={handleBlur("rpcUrl")}
                      showEyeIcon={false}
                      required={true}
                      disable={loading || isEdit}
                    />
                  )}
                </Field>

                <Field name="nativeCurrency">
                  {({ meta }) => (
                    <CustomTextInput
                      label={"Native currency"}
                      type="text"
                      error={meta.touched ? meta.error : null}
                      onChange={(e) => {
                        if (e.target.value.length <= 75)
                          handleChange("nativeCurrency")(e);
                      }}
                      placeHolderText={"Enter native currency url..."}
                      value={values.nativeCurrency}
                      onBlur={handleBlur("nativeCurrency")}
                      showEyeIcon={false}
                      required={true}
                      disable={loading || isEdit}
                    />
                  )}
                </Field>

                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Field name="chainId">
                    {({ meta }) => (
                      <CustomTextInput
                        label={"Chain ID"}
                        type="number"
                        error={meta.touched ? meta.error : null}
                        onChange={(e) => {
                          if (e.target.value.length <= 400)
                            handleChange("chainId")(e);
                        }}
                        placeHolderText={"Enter chain ID..."}
                        value={values.chainId}
                        onBlur={handleBlur("chainId")}
                        showEyeIcon={false}
                        required={true}
                        disable={loading || isEdit}
                      />
                    )}
                  </Field>
                  <Field name="priceInUsd">
                    {({ meta }) => (
                      <CustomTextInput
                        label={"Price in USD"}
                        type="number"
                        error={meta.touched ? meta.error : null}
                        onChange={(e) => {
                          if (e.target.value.length <= 300)
                            handleChange("priceInUsd")(e);
                        }}
                        placeHolderText={"Enter price in USD..."}
                        value={values.priceInUsd}
                        onBlur={handleBlur("priceInUsd")}
                        showEyeIcon={false}
                        required={true}
                        disable={loading}
                      />
                    )}
                  </Field>
                </div>
              </div>
            </div>

            <div className="formFooter">
              <button
                type="submit"
                disabled={loading}
                className="addbtn border p1060"
                onClick={() => {
                  handleSubmit();
                }}
              >
                {loading && <Spin className="spin" />}
                {isEdit ? "Edit" : "Add"}
              </button>
              <button
                type="submit"
                disabled={loading}
                className="cancelbtn border p1060"
                onClick={() => {
                  if (!isEdit) {
                    handleResetForm();
                  }
                  handleCloseModal();
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        )}
      </Formik>
    </div>
  );
};

export default AddOrEditBlockchain;
